// PageFactory.js

import $ from 'jquery';

import BaseVisualControlFactory from 'BaseVisualControlFactory.js';
//import factoryService   from 'FactoryService.js';
import constants        from 'Constants.js';
import sequenceService  from 'SequenceService.js';
import listService      from 'ListService.js';

import PageModel        from 'PageModel.js';
import PageView 		from 'form/PageView.js';

//=============================================================================
//
// Creates one page, given a factoryService parameter key, and a layout 
// position. The factory parameter defines the  control appearance through its
// specified template. It defines the rectangle of the control via a width
// and height from the factory parameter.
//
// NOTE: pages share a common set of model property values. E.g. change
// page width, and all pages of a a form change width.
//
// -Lou Mauget, December 5, 2015
//
//=============================================================================
class PageFactory extends BaseVisualControlFactory {
    pageView;

    constructor () {
        super();
    }

	createView( factoryKey, pos ) {

  		const attributes = this.createChildAttributes(  factoryKey, pos ) ;
        attributes.id = sequenceService.nextDomId();

        // Override some base attributes. THese come from theme properties someday
        // TODO Get from properties or default somewhere outside this module
        attributes.width  = 700;
        attributes.height = 900;
        attributes.backgroundColor = '~pageBgColor';
        attributes.backgroundImageAssetId = '~pageBgImage';
        attributes.backgroundImageStyle = "center";
        attributes.sharedSettingsTitle = 'Page Shared Settings';
        this.pageView =  new PageView( { model: new PageModel( attributes ), el: $(constants.FORM_ID),
            							pos: undefined, factoryKey: factoryKey, id: sequenceService.nextDomId() } );

        //listService.addPage( pageView.model.get('id'), pageView );
        return this.pageView;
	}

    remove(){
        this.pageView.remove();
        super.remove();
    }
}

const pageFactory = new PageFactory();
export default pageFactory;
